import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** The injected internal services object. */
export function useServices(): Vue['$services'] {
  return resolveInjected('$services');
}